import React, {useState, useEffect } from "react";
import AddFamilyModel from "./AddFamilyModel";
import { getNewFamilyList } from '../../../Redux/Actions/newJoinerAction';
import { useDispatch, useSelector } from "react-redux";
import {httpDeleteFamilyDetails} from '../../HR/onboarding/api/Calls';
import moment from 'moment';
import AddQualificationDetail from "./AddQualificationDetail";

const AddFamilyDetail = ({ emailCheck, userID,tab,setTab}) => {
    
    const dispatch = useDispatch();
    const { familyList } = useSelector((state) => state.NewJoinerReducer);
    
    useEffect(() => {
        dispatch(getNewFamilyList(userID))

    }, [userID])
    const [selected,setSelected] = useState([]);
    const [previous,setPrevious] = useState('');
    const handleUpdates = (familydetail) => {
   
        setSelected(familydetail);
    };
    const handleDelete = async (id) =>{
        await httpDeleteFamilyDetails(id).then((res) => {
            if (res.status) {
                dispatch(getNewFamilyList(userID))
                return alert(res.msg);
            } else {
                return alert(res.msg);
            }
        });
    }
    const saveFamilyDetails = () =>{
        setTab(3);
    }
    const previousFamilyDetails = () =>{
        setPrevious(1);
        setTab(1);
    }
    const handleOpenPopup = () => {
        setSelected(null);
    };
    return (
        <>
            <AddFamilyModel email={emailCheck} edit={selected} setSelected={setSelected} />
            <div className={`tab-pane fade ${tab === 2 ?'active show':''}`} id="familydetail" role="tabpanel" aria-labelledby="familydetail-tab">
                <div className="tab_content">
                    <button className="btn_5 float-end mb15" data-bs-toggle="modal" data-bs-target="#addfamilydetail" onClick={handleOpenPopup}>Add Family Detail</button>
                    <div className="dash_white_box_ttl mb25">FAMILY DETAIL</div>
                    <table className="monthly_table mt20">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Relationship</th>
                                <th>Age </th>
                                <th>Date of Birth</th>
                                <th>Occupation</th>
                                <th className="text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {familyList?.length > 0 ?
                                familyList?.map((item, keys) => {console.log(item)
                                    return (
                                        <tr key={keys}>
                                            <td>{item.name}</td>
                                            <td>{item.relationship}</td>
                                            <td>{item.age}</td>
                                            <td>{moment(item.dob).format('DD-MM-YYYY')}</td>
                                            <td>{item.occupation}</td>
                                            <td className="text-right">
                                                <button className="btn_7 mr05" 
                                                data-bs-toggle="modal"
                                                data-bs-target="#addfamilydetail"
                                                onClick={() => handleUpdates(item)}><i className="icon icon-pencil" /></button>
                                                <button className="btn_8" onClick={() => handleDelete(item.id)}><i className="icon icon-cross" /></button>
                                            </td>
                                        </tr>
                                    )
                                })
                                : 
                                <tr>
                                    <td colSpan={6} className="text-center">
                                        <div className="notfound">No Record found</div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                <div className="tab_footer text-end">
                    <button className="btn_5 float-start" onClick={previousFamilyDetails}>Previous</button>
                    <button className="btn_5" onClick={saveFamilyDetails}>Save & Next</button>
                </div>
            </div>
            <AddQualificationDetail tab={tab} userID={userID} setTab={setTab}/>
        </>
    )
}
export default AddFamilyDetail;